<template>
  <div style="background-color: #fafafa;">
    <div class="searchBox">
      <van-search class="search-box" background="#2D7FC7" shape="round" v-model="value" placeholder="搜索单号" show-action @search="onSearch" @input="onSearch"
                  @cancel="onSearch" @clear="onSearch">
      </van-search>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
        <div style="width: 100%;" v-for="(item) in list" class="card" :key="item.uuid"
             @click="openDetail(item)">
          <table class="layout" style="width: 100%;" >
            <tr style="width: 100%;">
              <td style="width: 60%;">
                <div class="header">
                  <span class="title">{{item.serialNumber}}</span>
                </div>
              </td>
            </tr>
            <tr style="width: 100%;">
              <td colspan="2" class="content" style="width: 100%;">
                <p><span>货品名称：</span><span>{{item.radName}}</span></p>
                <p><span>图号：</span><span>{{item.formulaName}}</span></p>
                <p><span>客户：</span><span>{{item.dealerIdname}}</span></p>
              </td>
            </tr>
            <tr style="width: 100%;">
              <td class="content" style="width: 50%;">
                <p><span>规格(高宽厚)：</span><span>{{item.custom_text_1}}</span></p>
                <p><span>排档方式：</span><span>{{item.custom_text_2}}</span></p>
                <p><span>创建时间：</span><span>{{item.createTime}}</span></p>
              </td>
              <td class="content" style="width: 50%;">
                <p><span>中心距：</span><span>{{item.centerSpacing}}</span></p>
                <p><span>柱/档数：</span><span>{{item.pieces}}</span></p>
                <p><span>创建人：</span><span>{{item.creatorIdname}}</span></p>
              </td>
            </tr>
          </table>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model="showFilter" closeable position="bottom" :style="{ height: '80%' }"
               :close-on-click-overlay="false">
      <van-nav-bar title="申请时间" left-text="取消" right-text="确定"
                   @click-left="onFilterClickLeft()" @click-right="onFilterClickRight()" />
      <table class="layout">
        <tr>
          <td>
            <van-field-date v-model="startTime" type="date" format="yyyy-MM-dd" label="开始日期"></van-field-date>
            <van-field-date v-model="endTime" format="yyyy-MM-dd" type="date" label="结束日期"></van-field-date>
          </td>
        </tr>
      </table>
    </van-popup>
  </div>
</template>

<script>
import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Icon} from 'vant';
import bomListService from "../../service/bomListService";
import VanFieldDate from "../../components/VantFieldDate";
import {formatDictionary} from "../../utils/dictionary";
import moment from "moment";
export default {
  data: function () {
    return {
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      value: '',
      showFilter: false,
      startTime: "",
      endTime: "",
    }
  },

  components: {
    VanFieldDate,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
  },
  computed:{
    userId() {
      return this.$store.getters.getUserId;
    }
  },
  methods: {
    async onLoad() {
      this.pageIndex++;
      let resp = await bomListService.getBomList(this.pageIndex, this.value, this.startTime, this.endTime);
      resp.data.Data.data.forEach(item => {
        item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm');
      });
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.loading = false;
      this.refreshing = false;
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    onSearch() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    showFilterPop(){
      this.showFilter = true;
    },
    onFilterClickLeft(){
      this.showFilter = false;
    },
    onFilterClickRight(){
      this.showFilter = false;
      this.onSearch();
    },
    openDetail(item) {
      this.$router.push({path:"/rad/BomDetailList",
        query:{
          bomId:item.uuid,
          radName:item.radName,
          custom_text_1:item.custom_text_1,
          centerSpacing:item.centerSpacing,
          custom_text_2:item.custom_text_2,
          pieces:item.pieces,
          formulaName:item.formulaName,
          dealerIdname:item.dealerIdname,
          custom_text_3:item.custom_text_3,
          custom_text_4:item.custom_text_4,
          custom_dropdown_1:item.custom_dropdown_1,
          calibername:item.calibername,
          colorname:item.colorname,
          waterFlowname:item.waterFlowname,
          isSpecials:item.isSpecials,
          custom_dropdown_2name:item.custom_dropdown_2name,
      }})
    },
  }
};

</script>
<style>
.card p {
  margin:10px 0;
}
.card p>span:first-child {
  flex: 0 0 4rem;
  text-align: right;
  margin-right: 20px;
}
.van-pull-refresh__head{
  display: none;
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom:0;
  position:fixed;
  width: 100%;
}
.psiConfirmCont{
  width:100%;
  margin:0 auto;
  overflow: hidden;

}
.searchBox {
  height: 3rem;
  box-sizing: border-box;
  margin-bottom: 2rem;
  top: 0;
  position:fixed;
  width: 100%;
  background-color: #2D7FC7;
  z-index:999;
}
</style>